export default {
    siteParams: {
        name: '移交服务平台',
        value: 'siteName',
        type: 'advance',
        advanceConfig: [
            { prop: 'escoCompanyNameCn', 'value': '平台名称' },
            { prop: 'escoCompanyNo', 'value': '平台编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', 'value': '平台名称' },
            { prop: 'escoCompanyNo', 'value': '平台编码' }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
        advanceCascade: 'companyCode'
    },
    companyNames: {
        name: '移交分公司',
        value: 'companyName',
        type: 'advance',
        advanceConfig: [
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
            { prop: 'escoCompanyNo', 'value': '分公司编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
            { prop: 'escoCompanyNo', 'value': '分公司编码' }
        ],
        advanceUrl: '/searchBrand',
        cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
    },
    receiptSiteNames: {
        name: '接收服务平台',
        value: 'siteName',
        type: 'advance',
        advanceConfig: [
            { prop: 'escoCompanyNameCn', 'value': '平台名称' },
            { prop: 'escoCompanyNo', 'value': '平台编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', 'value': '平台名称' },
            { prop: 'escoCompanyNo', 'value': '平台编码' }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#receiptSiteCode', 'escoCompanyNameCn#receiptSiteName'],
        advanceCascade: 'receiptCompanyCode#companyCode'
    },
    receiptCompanyNames: {
        name: '接收分公司',
        value: 'companyName',
        type: 'advance',
        advanceConfig: [
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
            { prop: 'escoCompanyNo', 'value': '分公司编码' }
        ],
        tableConfig: [
            { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
            { prop: 'escoCompanyNo', 'value': '分公司编码' }
        ],
        advanceUrl: '/searchBrand',
        cbParams: ['escoCompanyNameCn#receiptCompanyName', 'escoCompanyNo#receiptCompanyCode']
    },
    rules: {
        transType: [
            { required: true, message: '请选择移交类型', trigger: 'change' }
        ],
        companyName: [
            { required: true, message: '请选择移交分公司', trigger: 'change' }
        ],
        siteName: [
            { required: true, message: '请选择移交服务平台', trigger: 'change' }
        ],
        receiptCompanyName: [
            { required: true, message: '请选择接收分公司', trigger: 'change' }
        ],
        receiptSiteName: [
            { required: true, message: '请选择接收服务平台', trigger: 'change' }
        ],
        transferType: [
            { required: true, message: '请选择移交方式', trigger: 'change' }
        ],
        courierNumber: [
            { required: true, message: '请输入快递单号', trigger: 'blur' }
        ],
        receiptPersonName: [
            { required: true, message: '请输入接收人', trigger: 'blur' }
        ]
    }
};
